export default __webpack_public_path__ + "assets/quote_l.bcb6fdc2.svg";